<div class="tw-text-center">
  <img class="tw-mx-auto" src="../../../assets/images/bulb-icon.png" alt="bulb" />
  <h1 class="tw-text-fpurple tw-m-0 tw-text-2xl tw-font-bold">Welcome!</h1>
  <p class="tw-my-5 tw-text-base">
    Download the extension to start <br />
    using FlyMSG
  </p>

  <div class="tw-flex tw-justify-center tw-gap-4">
    <button
      (click)="navigateToExtension()"
      class="tw-mr-2.5"
      id="downloadExtension"
      type="button"
      vng-button
      variant="primary"
      aria-label="Download Extension"
    >
      Download Extension
    </button>
    <!-- R1: no `color` attribute today — the orange-outline look came entirely
         from the custom tailwind classes, which vng-button's "outline" variant
         (transparent bg + accent-orange text/border) reproduces exactly, so
         the now-redundant color classes are dropped (cheatsheet #20). -->
    <button
      (click)="remindMeLater()"
      class="tw-ml-2.5 tw-rounded"
      id="remindMeLater"
      type="button"
      vng-button
      variant="outline"
      aria-label="Remind Me Later"
    >
      Remind Me in 1-Min
    </button>

    <!-- <button (click)="dismiss()" class="no-color disabled" id="dismiss" type="button" vng-button
            aria-label="Dismiss">Dismiss</button> -->
  </div>
  <p class="tw-mt-5 tw-mb-2">
    <span>Already have extension?</span
    ><span class="tw-text-fplum tw-font-bold tw-cursor-pointer" (click)="displayExtensionPrompt()">
      Pin to browser</span
    >
  </p>
</div>
